// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { createAccountStyles } from "@tps/Overrides/Widgets/CreateAccount/CreateAccount";
import { hideElement, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

createAccountStyles.container = {
    css: css`
        display: flex;
    `,
    offsetCss: css`
        max-width: 950px;
    `,
};

createAccountStyles.pageTitleGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0;
    `,
};

createAccountStyles.formGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
    `,
};

createAccountStyles.userGridContainer = {
    gap: 20,
    css: css`
        &&& {
            max-width: 950px;
        }
    `,
};

createAccountStyles.existingCustomerGridItem = {
    width: 12,
};

createAccountStyles.existingCustomerRadioGroup = {
    css: css`
        > ${TypographyStyle} {
            line-height: 24px;
        }
    `,
};

createAccountStyles.formFieldGridItem = {
    width: [12, 12, 6, 6, 6],
};

createAccountStyles.formFieldTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            margin-left: 5px;
        `,
    },
};

createAccountStyles.emailAddressTextField = {
    labelProps: {
        css: css`
            display: flex;
        `,
    },
};

createAccountStyles.createAccountMessage = {
    width: 12,
};

createAccountStyles.acceptCreateAccountText = {
    size: 12,
    weight: "bold",
};

createAccountStyles.errorMsg = {
    css: css`
        margin-bottom: 10px;
    `,
};

createAccountStyles.reCaptchaGridItem = {
    width: 12,
    css: css`
        &:empty {
            ${hideElement}
        }
    `,
};

createAccountStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};

createAccountStyles.submitButton = {
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};
